import { render, staticRenderFns } from "./kanbanImg.vue?vue&type=template&id=2a817e46&"
import script from "./kanbanImg.vue?vue&type=script&lang=js&"
export * from "./kanbanImg.vue?vue&type=script&lang=js&"
import style0 from "./kanbanImg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports